module.exports = __webpack_public_path__ + "static/media/LK_Expand.f7d9d93d.svg";